import MediaContainer from './media_container';

const Media = MediaContainer;
export default Media;
